import EventGuidelineCreate from './EventGuidelineCreate';

export default EventGuidelineCreate;
